import axiosInstance from './axiosInstance'

export interface CustomerType {
  id:               number
  name:             string
  identityCode:     string
  shortDescription: string | null
  businessTypeCode: string
}

export async function getCustomerTypes(): Promise<CustomerType[]> {
  const res = await axiosInstance.get<{ data: CustomerType[] }>('/customer-types')
  return res.data.data
}
